import { getAccessToken } from "../../../utils/helpers/tokenHelper";

const initialState = {
  data: [],
  loading: false,
  error: null,
  pollingId: null,
  polling: false,
  selectedRows: [],
  filterValues: undefined,
};

export const newCount = (namespace) => (state = initialState, action) => {
  switch (action.type) {
    case `${namespace}/START_COUNTER`: {

      let pollingId = setInterval(() => {
        if (getAccessToken()) {
          action.fetch();
        } else {
          clearInterval(pollingId);
        }
      }, action.interval);

      return { ...state, polling: true, pollingId: pollingId };
    }
    case `${namespace}/STOP_COUNTER`: {
      clearInterval(state.pollingId);
      return { ...state, polling: false, pollingId: null };
    }
    case `${namespace}/GET_REQUEST_REQUEST`: {
      return { ...state, data: action.data, loading: true };
    }
    case `${namespace}/GET_REQUEST_SUCCESS`: {
      return { ...state, data: action.data, loading: false };
    }
    case `${namespace}/GET_REQUEST_FAILURE`: {
      return { ...state, data: action.data, loading: false };
    }

    default:
      return state;
  }
};
